<template>
  <main>
    <div class="p-4">
      <h2 class="mb-3">Procesos de automatización</h2>
      <a-table
        bordered
        :loading="isLoading"
        :columns="automation.columns"
        :data-source="automation.data"
        :pagination="{ hideOnSinglePage: true }"
      >
        <a-tag :color="record ? 'green' : 'orange'" slot="published" slot-scope="record">
          {{ record ? 'Si' : 'No' }}
        </a-tag>
        <span slot="actions" slot-scope="record" class="d-flex" style="gap: .5rem">
          <a-tooltip>
            <template slot="title">
              {{ record.published ? 'Despublicar' : 'Publicar' }}
            </template>
            <a-button
              shape="circle"
              :icon="record.published ? 'delete' : 'thunderbolt'"
              @click="showConfirmModal(record)"
            ></a-button>
          </a-tooltip>
          <a-tooltip>
            <template slot="title">
              Editar
            </template>
            <a-button
              shape="circle"
              icon="edit"
              @click="$router.push(record.route)"
            ></a-button>
          </a-tooltip>
        </span>
        <!-- <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
          {{ record.description }}
        </p> -->
      </a-table>

      <!-- No solo mostrar el error, sino que te lleve a crear el documento faltante (los modals filtrados por el tipo apropiado - en el caso de un nuevo que vaya al nuevo de ese tipo)
       -->

      <a-modal
        title="¿Estas seguro?"
        :visible="confirmModal.visible"
        :confirm-loading="confirmModal.loading"
        cancelText="Cancelar"
        okText="Confirmar"
        @ok="tooglePublish"
        @cancel="rowForChangeStatus = null; confirmModal.visible = false;"
      >
        <p>{{ confirmModal.text }}</p>
      </a-modal>

      <div class="mt-3">
        <a-button type="primary" @click="$router.push('/automatizacion/processes')">Nuevo</a-button>
      </div>
    </div>
  </main>
</template>

<script>
import { defineComponent } from 'vue'
import commonsApi from '@/api/commons'
import moment from 'moment'
import 'moment/locale/es'

moment.locale('es')

export default defineComponent({
  data: () => ({
    isLoading: false,
    confirmModal: {
      text: 'Content of the modal',
      visible: false,
      loading: false
    },
    rowForChangeStatus: null,
    servicePicker: {
      data: [],
      columns: []
    },
    automation: {
      data: [],
      columns: [
        { title: 'Servicio', dataIndex: 'service', key: 'service' },
        { title: 'Publicado', dataIndex: 'published', key: 'published', scopedSlots: { customRender: 'published' } },
        { title: 'Creado', dataIndex: 'createdAt', key: 'createdAt' },
        { title: 'Acciones', dataIndex: '', key: 'x', scopedSlots: { customRender: 'actions' } }
      ]
    }
  }),
  methods: {
    obtainDescription (item) {
      let text = 'dadada'

      return text
    },
    obtainService (item) {
      let text = ''
      if (item.service === 'processes') {
        text = 'Trámite'
      }
      return text
    },
    showConfirmModal (row) {
      this.rowForChangeStatus = row
      if (row.published) {
        this.confirmModal.text = 'Vamos a despublicar el proceso y dejará de tener efecto.'
      } else {
        this.confirmModal.text = 'Vamos a publicar el proceso y comenzará a tener efecto.'
      }
      this.confirmModal.visible = true
    },
    async tooglePublish () {
      try {
        this.confirmModal.loading = true
        if (this.rowForChangeStatus.published) {
          await commonsApi.axiosPutWrapper('/automation/unpublish', { id: this.rowForChangeStatus._id })
        } else {
          await commonsApi.axiosPutWrapper('/automation/publish', { id: this.rowForChangeStatus._id })
        }
        await this.getAutomations()
      } catch (error) {
        console.log(error)
      } finally {
        this.confirmModal.visible = false
        this.confirmModal.loading = false
      }
    },
    async getAutomations () {
      const response = await commonsApi.axiosGetWrapper('/automation')
      this.automation.data = response.data.rows.map((el, index) => {
        return {
          ...el,
          createdAt: moment(el.createdAt).format('DD [de] MMM, YYYY - hh:mm'),
          key: index,
          service: this.obtainService(el),
          route: `/automatizacion/${el.service}/editar/${el._id}`,
          description: this.obtainDescription(el)
        }
      })
    }
  },
  async created () {
    this.isLoading = true
    await this.getAutomations()
    this.isLoading = false
  }
})
</script>
